/**
 * @description 出入库管理
 */
import request from "@/utils/request";

// 查询详情(出库、入库)
export function queryDetailById(id) {
  return request({
    url: `/bound/getDetailInfoV164/${id}`,
    method: "get",
  });
}
export function boundInStatistics(params) {
  return request({
    url: `/bound/boundInStatistics`,
    method: "get",
    params,
  });
}

// 批量删除（出库、入库）
export function batchDeleteByIds(ids) {
  return request({
    url: `/bound/deleteBatch/${ids}`,
    method: "delete",
  });
}

//批量开票
export function changeInvoicingStatus(data) {
  return request({
    url: `/bound/changeInvoicingStatus`,
    method: "post",
    data,
  });
}

/**------------------入库--------------------- */
// 分页查询（入库）
export function queryTableIn(params) {
  return request({
    url: "/bound/selectBoundPageV164",
    method: "get",
    params,
  });
}

// 新增（入库）
export function insertBoundIn(data) {
  return request({
    url: "/bound/saveBoundInV164",
    method: "post",
    data,
  });
}

// 编辑（入库）
export function editBoundApi(data) {
  return request({
    url: "/bound/updateBoundInV164",
    method: "post",
    data,
  });
}

//获取厂站列表
export function getFactoryStationList() {
  return request({
    url: "/station/list",
    method: "get",
  });
}

//提交审核
export function handleProcessApi(id) {
  return request({
    url: `/approval/submitAuditingV164/${id}`,
    method: "put",
  });
}

/**------------------出库--------------------- */
// 分页查询（出库）
export function queryTableOut(params) {
  return request({
    url: "/bound/selectBoundPageV164",
    method: "get",
    params,
  });
}

// 查询出库数据
export function queryBoundTotal(params) {
  return request({
    url: "/bound/total",
    method: "get",
    params,
  });
}

// 新增（出库）
export function insertBoundOut(data) {
  return request({
    url: "/bound/saveBoundOutV164",
    method: "post",
    data,
  });
}

// 分页查询（入库）
export function queryTableRequisition(params) {
  return request({
    url: "/bound/noBoundAcceptMaterialPageV164",
    method: "get",
    params,
  });
}
// 入库单导入
export function importBound(data) {
  return request({
    url: "/bound/importWarehouse",
    method: "post",
    data,
  });
}

// 领料单导入
export function importBoundPicking(data) {
  return request({
    url: "/bound/importPicking",
    method: "post",
    data,
  });
}
